import { Link } from "react-router-dom";

export default function Logo({ className = "", size = 40, showText = false }) {
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/singvi-logo.png"
        alt="SINGVI KARAOKE"
        style={{ height: size, width: size }}
        className="object-contain drop-shadow-[0_0_12px_rgba(255,0,127,0.5)]"
      />
      {showText && (
        <span className="font-head font-extrabold text-lg tracking-tight leading-none">
          SINGVI<span className="text-gradient"> KARAOKE</span>
        </span>
      )}
    </Link>
  );
}
